import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';
import Cookies from "js-cookie";
import ValidateAutoCrawlStatus from './Components/Notifier/Notifier';

const jwtToken = Cookies.get("jwt_token");
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.interceptors.request.use(
  (request) => {
    const secondToken = Cookies.get("jwt_token");
    if (jwtToken !== secondToken) {
      Cookies.remove('jwt_token')
      Cookies.remove('UserLogin')
      Cookies.remove('first_name')
      Cookies.remove('last_name')
      Cookies.remove('Role')
      window.location.href = "/";
    }
    return request

  },
  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use((response) => {
  return response
},
  (error) => {
    if (error.response.status === 401) {
      Cookies.remove('jwt_token')
      Cookies.remove('UserLogin')
      Cookies.remove('first_name')
      Cookies.remove('last_name')
      Cookies.remove('Role')
      window.location.href = "/";
    }
    return Promise.reject(error)
  }

)

ValidateAutoCrawlStatus();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
